import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { CognitoService } from "src/app/shared/services/cognito.service";
import {
  showError,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";
import { ModalResetPasswordTokenComponent } from "../../components/modal-reset-password-token/modal-reset-password-token.component";
import { endpoints } from "src/environments/endpoints";
import { CoreApiService } from "src/app/core/core-api.service";

@Component({
  selector: "app-lost-password",
  templateUrl: "./lost-password.component.html",
  styleUrls: ["./lost-password.component.scss"],
})
export class LostPasswordComponent implements OnInit {
  formForgotPassword: FormGroup;
  modalRef: MDBModalRef;

  constructor(
    private router: Router,
    private modalService: MDBModalService,
    private cognitoService: CognitoService,
    private coreApiService: CoreApiService,
  ) {}

  ngOnInit() {
    this.createFormForgotPassword();
  }

  send() {
    if (this.formForgotPassword.valid) {
      this.cognitoService.resetPassword(this.document.value).subscribe(
            (resp) => {
              if (!this.coreApiService.isJson(resp)) {
                this.modalRef = this.modalService.show(
                    ModalResetPasswordTokenComponent,
                    {
                      ignoreBackdropClick: true,
                      scroll: true,
                      data: { username: this.document.value, email: resp},
                    }
                  );
              } else {
                showError("", JSON.parse(resp).descricaoErro[0])
              }
            },
            (e) => {
              showError("", e.message);
            }
          )
        ,
        (e) => {
          showError("", e.message);
        }
    } else {
      return showError(
        "",
        "O campo Documento Identificador não podem ser vázios."
      );
    }
  }

  createFormForgotPassword() {
    this.formForgotPassword = new FormGroup({
      document: new FormControl("", [
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(14),
      ]),
    });
  }

  get document() {
    return this.formForgotPassword.get("document");
  }
}
